<template>
    <article
        class="pf-select-with-search"
        ref="selectFilter"
        v-click-outside="onClickOutside">
        <div class="pf-select-with-search__trigger-wrap">
            <div
                class="pf-select-with-search__label"
                v-html="label"></div>
            <div
                @click="toggleFilterList"
                class="pf-select-with-search__trigger"
                :class="{active: filterList, hasValue: filterActiveFieldsId.length !== 0}">
                <span
                    class="pf-select-with-search__text"
                    v-html="filterActiveFieldsName.length !== 0 ? filterActiveFieldsName.join(', ') : placeholder">
                </span>
                <button
                    v-if="filterActiveFieldsId.length !== 0"
                    @click.prevent.stop="clearLocation"
                    class="pf-select-with-search__clear clear-btn"></button>
            </div>
        </div>
        <div
            v-show="filterList"
            class="pf-select-with-search__list-container">
            <div class="pf-select-with-search__list-wrap">
                <ul class="pf-select-with-search__list">
                    <li class="pf-select-with-search__search">
                        <div class="pf-select-with-search__fieldgroup">
                            <input
                                type="text"
                                :id="`selectCheckboxSearch${thisComponentDubleCount}`"
                                name="selectCheckboxSearch"
                                placeholder="Поиск"
                                v-model="searchValue"
                                @input="searchHandler" />
                            <button
                                v-if="clearListButton"
                                class="pf-select-with-search__search-clear clear-btn"
                                type="button"
                                @click.prevent="clearListSearch"
                                aria-label="Очистить поле поиска по регионам"></button>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875Z"
                                    fill="black"/>
                            </svg>
                        </div>
                    </li>
                    <template v-if="searchValue.length === 0">
                        <li
                            v-for="(item, name, i) in filterData.structure"
                            :key="i"
                            class="pf-select-with-search__item">
                            <div class="pf-select-with-search__item-wrap">
                                <button
                                    @click.prevent="toggleSubList"
                                    class="pf-select-with-search__item-trigger"></button>
                                <div
                                    class="pf-select-with-search__item-field"
                                    v-html="name"
                                    @click="toggleSubList"></div>
                            </div>
                            <ul
                                style="display: none"
                                class="pf-select-with-search__sublist">
                                <li class="pf-select-with-search__subitem">
                                    <input
                                        class="visually-hidden"
                                        :name="name"
                                        :id="`chooseAll-${i}${thisComponentDubleCount}`"
                                        data-id="chooseAll"
                                        :value="name"
                                        @change.stop.prevent="choosenAria(name)"
                                        type="checkbox"/>
                                    <label
                                        :for="`chooseAll-${i}${thisComponentDubleCount}`"
                                        v-html="'Выбрать все'"></label>
                                </li>
                                <li
                                    v-for="(subitem, subname, k) in item"
                                    :key="subname"
                                    class="pf-select-with-search__subitem">
                                    <input
                                        class="visually-hidden"
                                        :name="fieldName"
                                        :id="`${subname}${thisComponentDubleCount}`"
                                        :value="subname"
                                        v-model="filterActiveFieldsId"
                                        @change.stop.prevent="checkboxesHandler(name)"
                                        type="checkbox"/>
                                    <label
                                        :for="`${subname}${thisComponentDubleCount}`"
                                        v-html="subitem"></label>
                                </li>
                            </ul>
                        </li>
                    </template>
                    <template v-else>
                        <ul class="pf-select-with-search__sublist pf-select-with-search__sublist--search">
                            <li
                                v-for="(item, i) in foundOption"
                                :key="i"
                                class="pf-select-with-search__subitem pf-select-with-search__subitem--search">
                                <input
                                    class="visually-hidden"
                                    :name="fieldName"
                                    :id="`${item[0]}${thisComponentDubleCount}`"
                                    :value="item[0]"
                                    v-model="filterActiveFieldsId"
                                    @change="checkboxesHandler(null)"
                                    type="checkbox"/>
                                <label
                                    :for="`${item[0]}${thisComponentDubleCount}`"
                                    v-html="item[1]">
                                </label>
                            </li>
                        </ul>
                    </template>
                </ul>
            </div>
            <div class="pf-select-with-search__btns-wrap">
                <button
                    class="pf-select-with-search__btn pf-select-with-search__btn--clear"
                    :class="{disabled: filterActiveFieldsId.length === 0}"
                    @click.prevent="clearLocation">
                    Очистить
                </button>
                <button
                    class="pf-select-with-search__btn pf-select-with-search__btn--apply"
                    :class="{disabled: filterActiveFieldsId.length === 0}"
                    @click.prevent="applyFilter">
                    Применить
                </button>
            </div>
        </div>
    </article>
</template>

<script>
    import vClickOutside from 'click-outside-vue3'

    export default {
        name: 'SelectFilterCheckbox',
        directives: {
            clickOutside: vClickOutside.directive
        },
        data() {
            return {
                filterList: false,
                filterActiveFieldsId: [],
                filterActiveFieldsName: [],
                clearListButton: false,
                searchValue: '',
            }
        },
        props: {
            filterData: Object,
            placeholder: {
                type: String,
                default: ''
            },
            fieldName: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            onloadValue: {
                type: String,
                default: ''
            },
            thisComponentDubleCount: {
                type: String,
                default: ''
            }
        },
        emits: ['choosen-filter-items'],
        methods: {
            toggleFilterList () {
                if (this.filterList) {
                    this.$emit('choosenFilterItems', this.fieldName, this.filterActiveFieldsId)
                }

                this.filterList = !this.filterList
            },

            toggleSubList () {
                const targetWrap = event.target.closest('.pf-select-with-search__item-wrap')
                const target = targetWrap.nextElementSibling;
                if (target.offsetHeight === 0) {
                    target.style.display = 'block'
                    targetWrap.classList.add('active')
                    target.style.maxHeight = `${target.scrollHeight}px`
                } else {
                    targetWrap.classList.remove('active')
                    target.style.maxHeight = 0
                    setTimeout(() => {
                        target.style.display = 'none'
                    }, 300)
                }
            },

            applyFilter () {
                if (this.filterList) {
                    this.filterList = false
                    this.$emit('choosenFilterItems', this.fieldName, this.filterActiveFieldsId)
                }
            },

            onClickOutside () {
                this.applyFilter()
            },

            isArraysEqual(firstArray, secondArray) {
                return firstArray.sort().toString() === secondArray.sort().toString();
            },

            checkboxesHandler (sectionName) {
                if (sectionName) {
                    const sectionCheckboxChooseAll = this.$refs.selectFilter.querySelector(`input[name="${sectionName}"]`)
                    if (this.isArraysEqual(this.filterActiveFieldsId, Object.keys(this.filterData.structure[sectionName]))) {
                        sectionCheckboxChooseAll.checked = true
                    } else {
                        sectionCheckboxChooseAll.checked = false
                    }
                } else {
                    if (event.target.checked) {
                        this.filterActiveFieldsId.push(event.target.value)
                        this.filterActiveFieldsId = [...new Set(this.filterActiveFieldsId)]
                    }
                }

                this.filterActiveFieldsName = Object.values(this.filterActiveFieldsId).map(el => this.filterData.values[el])
            },

            choosenAria (item) {
                const checkboxesSections = this.$refs.selectFilter.querySelectorAll('input[data-id="chooseAll"]')
                checkboxesSections.forEach(el => {
                    if (el.getAttribute('name') !== item) {
                        el.checked = false
                    }
                })

                if (event.target.checked) {
                    this.filterActiveFieldsName = Object.values(this.filterData.structure[item])
                    this.filterActiveFieldsId = Object.keys(this.filterData.structure[item])
                    return
                }
                
                this.filterActiveFieldsName = []
                this.filterActiveFieldsId = []
            },

            showClearListBtn () {
                this.searchValue.length ?
                this.clearListButton = true :
                this.clearListButton = false
            },

            clearListSearch () {
                this.searchValue = ''
                this.clearListButton = false
            },

            searchHandler () {
                this.showClearListBtn()
            },

            clearLocation () {
                this.filterActiveFieldsName = []
                this.filterActiveFieldsId = []
                const checkedCheckboxes = this.$refs.selectFilter.querySelectorAll('input[type="checkbox"]:checked')
                checkedCheckboxes.forEach(el => {
                    el.checked = false
                })
                this.$emit('choosenFilterItems', this.fieldName, this.filterActiveFieldsId)
            },
        },

        computed: {
            foundOption () {
                return Object.entries(this.filterData.values).filter(item =>
                    item[1].toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1)
            },
        },

        created() {
            if (this.onloadValue) {
                const regionsArr = this.onloadValue.split(',')
                this.filterActiveFieldsId = regionsArr
                regionsArr.forEach(el => {
                    this.filterActiveFieldsName.push(this.filterData.values[el])
                })
                
            }
        }
    }
</script>